import React from 'react';
interface TestimonialCardProps {
  initials: string;
  stars: number;
  quote: string;
  name: string;
  location: string;
  level: string;
}
function TestimonialCard({
  initials,
  stars,
  quote,
  name,
  location,
  level
}: TestimonialCardProps) {
  return <div className="bg-black border border-[#FFD700]/30 rounded-2xl p-5 flex flex-col gap-3" data-id="element-323">
      <div className="flex items-center gap-3" data-id="element-324">
        <div className="w-10 h-10 rounded-full bg-[#FFD700]/20 border border-[#FFD700]/40 flex items-center justify-center text-[#FFD700] font-black text-xs flex-shrink-0" data-id="element-325">
          {initials}
        </div>
        <div data-id="element-326">
          <div className="text-[#FFD700] text-xs" data-id="element-327">{'⭐'.repeat(stars)}</div>
          <div className="text-white font-bold text-sm" data-id="element-328">{name}</div>
          <div className="text-gray-400 text-xs" data-id="element-329">
            📍 {location} | {level}
          </div>
        </div>
      </div>
      <p className="text-gray-300 text-sm leading-relaxed italic" data-id="element-330">"{quote}"</p>
    </div>;
}
export function TestimonialsSection() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-331">
      <div className="max-w-5xl mx-auto" data-id="element-332">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-4" data-id="element-333">
          Más testimonios de catequistas
          <span className="text-[#FFD700]" data-id="element-334"> que ya lo usan</span>
        </h2>
        <p className="text-gray-400 text-center mb-10" data-id="element-335">
          +500 catequistas de Argentina ya lo usan
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-336">
          <TestimonialCard initials="FL" stars={5} quote="Lo que más valoro es que está organizado por año real y por madurez de fe. Mis alumnos de 4° año por fin conectan la ética con el Evangelio. El Tomo 10 es extraordinario." name="Fernando L." location="Tucumán" level="Docente de Religión | Secundaria" data-id="element-337" />
          <TestimonialCard initials="VT" stars={5} quote="Tengo grupos muy numerosos y poco tiempo de preparación. El Bono 6 del Calendario Litúrgico me cambió la vida. Las aperturas de 5 minutos son algo que no sabía que necesitaba hasta que las usé." name="Valentina T." location="Santa Fe" level="Catequista parroquial | Primaria" data-id="element-338" />
          <TestimonialCard initials="PA" stars={5} quote="La primera vez que entregué el informe de evidencias a los directivos... fue la primera vez en años que me felicitaron en vez de pedirme más papeles. Vale el pack solo por eso." name="Pablo A." location="Neuquén" level="Docente de Catequesis | Colegio" data-id="element-339" />
          <TestimonialCard initials="SC" stars={5} quote="Tenía miedo de que fuera material genérico. Cuando abrí el Tomo 7 encontré exactamente lo que le falta al adolescente argentino: fe que piensa, que cuestiona, que conecta con su vida real. Mis chicos de 1° Secundaria terminan la clase pidiendo más." name="Santiago C." location="La Plata" level="Catequista | Secundaria" data-id="element-340" />
        </div>
      </div>
    </section>;
}